module.exports = __webpack_public_path__ + "img/group.d3fdcb74.svg";